import { z } from 'zod';

export const MetricDefinitionCalibrationFraming = z
  .enum([
    'Positive', // This means that the higher the metric value is, the better the outcome. i.e. performance, promotion, hiring.
    'Negative', // This means that the lower the metric value is, the better the outcome. i.e. attrition, turnover, searching, arrests, etc.
  ])
  .describe('MetricDefinitionCalibrationFraming');

export const MetricDefinitionCalibrationFramingValues = Object.values(
  MetricDefinitionCalibrationFraming.Values,
);

export type MetricDefinitionCalibrationFraming = z.infer<
  typeof MetricDefinitionCalibrationFraming
>;
